export const settings = {
  API_HOST: "https://test.derbyshire-pep.org.uk",
  //API_HOST: "https://test.assetforschools.com",
  CORS_ALLOWED_ORIGINS: "",
  // DCC_API_HOST: "",
};
